import { render } from "./progress_spinner.vue?vue&type=template&id=0b44452e&ts=true"
import script from "./progress_spinner.vue?vue&type=script&lang=ts"
export * from "./progress_spinner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__